import { applyMiddleware, compose, createStore } from "redux";
import Thunk from "redux-thunk";
import index from "./reducers";

export function configureStore(initialState) {
  //redux devtool
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    index,
    initialState,
    composeEnhancers(applyMiddleware(Thunk))
  );
}
